<div class="d-flex flex-column">
    <!-- <i class="fas fa-close pointer" (click)="closeNav()" style="right: 18px;
        display: block;
        position: absolute;
        top: 14px;"></i> -->
    <div class="slider-container pt-3 pb-0">
      <div class="silider-sticky-ontop">
        <div class="d-flex">
            <ng-content select="[talentPoolBulkGrab]"></ng-content>
            <div *ngIf="!this.aiSourcingService.isAISourcingTab && !this.aiSourcingService.isResumeScreenTab">
                <div class="circular-img mr-3 text-capitalize" [ngClass]="{
                    'lavender-circle': data.currentIndex % 4 == 0,
                    'yellow-circle': data.currentIndex % 4 == 1,
                    'blue-circle': data.currentIndex % 4 == 2,
                    'teal-circle': data.currentIndex % 5 == 3
                  }">{{(calledfrompage === 'personsearchlistingpage' ? data.full_name_with_middle_name : data.full_name)?.charAt(0)}}</div>
            </div>

            <div class="w-100">
                <div class="d-flex justify-content-between w-100">
                    <div>
                        <p class="f-16 font-weight-500 icon-color mb-1 text-capitalize f-16 font-weight-600 pointer" (click)="handleChildEvents('openNav')"
                        *ngIf="calledfrompage === 'personsearchlistingpage' ? data?.full_name_with_middle_name : data?.full_name">
                        {{(calledfrompage === 'personsearchlistingpage' ? data.full_name_with_middle_name : data.full_name) | titlecase}}
                        <span *ngIf="data?.is_unsubscribed" class="px-1 ml-1" matTooltip="Unsubscribed from Email Campaign" [matTooltipClass]="{ 'red-tooltip text-black': true }" style="color: #e54f7a; background-color: #fff5f8; border-radius: 100px;">
                            <i class="fa-solid fa-envelopes-bulk f-12"></i>
                        </span>
                    </p>
                    <p class="f-16 icon-color mb-1 f-14" matTooltip="{{currentJobTitle | titlecase}} at {{currentCompany | titlecase}}" [matTooltipClass]="{ 'red-tooltip': true }" *ngIf="currentJobTitle">
                      <span class="line-clamp">
                        <span *ngIf="currentJobTitle" class="text-capitalize" [innerHTML]="highlightInfo(currentJobTitle, 'currentjobtitle')"></span>
                        <span *ngIf="currentJobTitle && currentCompany"> at </span>
                        <span *ngIf="currentCompany" class="text-capitalize" [innerHTML]="highlightInfo(currentCompany, 'currentcompany')"></span>
                      </span>
                      <span *ngIf="!currentJobTitle && currentSchool" class="text-capitalize">Student at {{currentSchool}}</span>
                    </p>
                    <p class="f-16 icon-color mb-1 f-14" matTooltip="Studen at {{currentSchool | titlecase}} "
                      [matTooltipClass]="{ 'red-tooltip': true }" *ngIf="!currentJobTitle && currentSchool">
                      <span class="text-capitalize">Student at {{currentSchool}}</span>
                    </p>
                      </div>

                    <ng-content select="[addToTalentPool]" *ngIf="!currentUrl?.includes('ai-sourcing')"></ng-content>

                    <button data-testid="auto-app-person-search-candidate-slider-button-1" *ngIf="currentUrl?.includes('ai-sourcing')" class="btn-trms-light" matTooltip="Download PDF" [matTooltipClass]="{ 'red-tooltip text-black': true }" style=" min-width: 30px" (click)="autpolitCandidateExportToPDF()">
                      <i class="fa-solid fa-file-pdf" *ngIf="!autopilotPdfExportInPrgoress"></i>
                      <img src="../../assets/rolling-loader.gif" *ngIf="autopilotPdfExportInPrgoress" style="width: 18px;" alt="">
                    </button>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="f-12 text-9696 d-flex align-items-center w-100">
                        <i class="far fa-map-marker-alt mr-1" *ngIf="currentLocation"></i>
                        <span *ngIf="currentLocation" class="text-capitalize" [innerHTML]="highlightInfo(currentLocation, 'location')"></span>
                        <i class="fas fa-circle text-d9d9d9 mx-2" style="font-size:5px" *ngIf="currentLocation && totalTenure"></i>
                        <span matTooltip="Total years of experience" [matTooltipClass]="{ 'red-tooltip': true }"  matTooltipPosition="right">
                          <i class="far fa-briefcase mr-1" *ngIf="totalTenure"></i>
                          <span *ngIf="totalTenure">{{totalTenure}}</span>
                        </span>

                        <i class="fas fa-circle text-d9d9d9 mx-2 mr-1 text-9696" style="font-size:5px" *ngIf="totalTenure && (linkedin_url || twitter_url || facebook_url)"></i>

                        <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px" *ngIf="currentLocation && !totalTenure && (linkedin_url || twitter_url || facebook_url)"></i>
                        <a data-testid="auto-app-person-search-candidate-slider-a-1" target="_blank" rel="noopener noreferrer" *ngIf="linkedin_url" (click)="openUrl(linkedin_url, 'linkedin')" class="mr-2">
                          <!-- <i class="fab fa-linkedin-in" style="color: #0652ba;"></i> -->
                          <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/fa0r989gg"
                            style="height: 14px; margin-right: 10px;" alt="Linkedin" title="Linkedin"> -->
                            <i class="fa fa-linkedin-square f-16"  aria-hidden="true" style="color: #0652ba;"></i>

                        </a>
                        <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/fa0r989gg" style="height: 14px; margin-right: 10px;" *ngIf="isBooleanlinkedin_url) &&linkedin_url" alt="Linkedin" title="Linkedin"> -->
                        <!-- <i class="fab fa-linkedin text-9696" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(linkedin_url) && linkedin_url" alt="Linkedin" title="Linkedin"></i> -->
                        <a data-testid="auto-app-person-search-candidate-slider-a-2" target="_blank" rel="noopener noreferrer" *ngIf="twitter_url && !isBoolean(twitter_url)" (click)="openUrl(twitter_url, 'twitter')" class="mr-2">
                          <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/sh2cap19p"
                                                      style="height: 14px; margin-right: 10px;" alt="Twitter" title="Twitter"> -->
                          <i class="fa-brands fa-square-x-twitter f-16" style="color: #000000;"></i>
                        </a>
                        <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/sh2cap19p" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(twitter_url) && twitter_url" alt="Twitter" title="Twitter"> -->
                        <i class="fa-brands fa-square-x-twitter text-9696" style="height: 14px; margin-right: 10px;" alt="Twitter" title="Twitter" *ngIf="isBoolean(twitter_url) && twitter_url" alt="Twitter" title="Twitter"></i>
                        <a data-testid="auto-app-person-search-candidate-slider-a-3" target="_blank" rel="noopener noreferrer" *ngIf="github_url && !isBoolean(github_url)" (click)="openUrl(github_url, 'github')" class="mr-2">
                          <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/i2monblpk" style="height: 14px; margin-right: 10px;" alt="Github" title="Github"> -->
                          <i class="fab fa-github f-16" style="color: black;"></i>
                        </a>
                        <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/i2monblpk" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(github_url) && github_url" alt="Github" title="Github"> -->
                        <!-- <i class="fab fa-github text-9696" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(github_url) && github_url" alt="Github" title="Github"></i> -->
                        <a data-testid="auto-app-person-search-candidate-slider-a-4" target="_blank" rel="noopener noreferrer" *ngIf="facebook_url && !isBoolean(facebook_url)" (click)="openUrl(facebook_url, 'facebook')" class="mr-2">
                          <i class="fab fa-facebook f-16" style="color: #1773ea;"></i>
                        </a>
                        <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/voakkd5nz"> -->
                        <i class="fab fa-facebook-square text-9696 f-16" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(facebook_url) && facebook_url" alt="Facebook" title="Facebook"></i>
                        <div class="f-12 align-items-center text-9696 ml-auto" *ngIf="jobLastVerifiedDate"><span><i class="fas fa-badge-check text-webbtree-green"></i></span> Last verified: {{jobLastVerifiedDate}} ago</div>

                    </div>
                </div>
            </div>
        </div>
        <div class="pt-2" *ngIf="currentUrl?.includes('ai-sourcing') || currentUrl?.includes('resume-screen')">
            <ng-content select="[shortlist]" *ngIf="currentUrl?.includes('ai-sourcing')"></ng-content>

            <app-ai-sourcing-profile-slider></app-ai-sourcing-profile-slider>


        </div>
      </div>
    <div class="wccard d-flex justify-content-between tab-sticky-on-scroll-up" style="border-bottom: 2px solid #d5dee6;">
        <div class="d-flex align-items-center" style="margin-bottom: -2px;">
            <span class="py-3 pointer px-8 text-9696 gen-ai-text" *ngIf="this.aiSourcingService.isAISourcingTab" (click)="onTabChange('autopilot')" [ngClass]="{'isActive font-weight-600': autopilotTab}">
             <i class="fa-sharp fa-solid fa-sparkles"></i> Autopilot<sup class="gen-ai-text f-10" style="font-size: 10px;">AI</sup>
            </span>
             <span class="py-3 pointer px-8 text-9696 gen-ai-text" *ngIf="this.aiSourcingService.isResumeScreenTab" (click)="onTabChange('screen')" [ngClass]="{'isActive font-weight-600': screenTab}">
             <i class="fa-sharp fa-solid fa-sparkles mr-2"></i> Screen<sup class="gen-ai-text f-10" style="font-size: 10px;">AI</sup>
            </span>
            <span class="py-3 pointer px-8 text-9696" (click)="onTabChange('profile')"
                [ngClass]="{'isActive font-weight-600 mb--4': profileTab}" *ngIf="calledfrompage !== 'resume-screen' || (calledfrompage == 'resume-screen' && data?.jobsource !== 'import')">
                <i class="fas fa-user mr-2" [ngClass]="{'font-weight-600': profileTab}"></i>
                Profile
            </span>
            <span  *ngIf="parent !== 'TalentpoolRecommendedCandidateListComponent' && calledfrompage !== 'resume-screen'" class="py-3 pointer px-8 text-9696" (click)="onTabChange('contact')"
                [ngClass]="{'isActive font-weight-600 mb--4': contactTab}">
                <i class="fas fa-address-book mr-2" [ngClass]="{'font-weight-600': contactTab}"></i>
                Contact
            </span>
            <span  *ngIf="parent !== 'TalentpoolRecommendedCandidateListComponent' && calledfrompage !== 'resume-screen' && calledfrompage !== 'archivepage' && calledfrompage !== 'reviewpage'  && data?.calledfrompage !== 'shortlistpage'" class="py-3 pointer pr-6 pl-4 text-9696"  (click)="onTabChange('similarcandidates')"
            [ngClass]="{'isActive font-weight-600': similarTab, 'font-weight-1000': data?.parent !== 'AiSourcingProfileCardComponent'}" >
            <i class="fas fa-users mr-2" [ngClass]="{'font-weight-600': similarTab}"></i>
            Similar Candidates
            <span class="circle ml-1" *ngIf="totalresultcount && similarcandidates?.length > 0 && data?.calledfrompage !== 'reviewpage'">
                <span class="circle__content">{{totalresultcount > 99 ? '99+': totalresultcount}}</span>
            </span>

        </span>

        <span *ngIf="parent !== 'TalentpoolRecommendedCandidateListComponent' && calledfrompage !== 'resume-screen' && data?.calledfrompage !== 'reviewpage' && data?.calledfrompage !== 'shortlistpage' && data?.calledfrompage !== 'archivepage'" class="py-3 pointer px-8 text-9696" (click)="onTabChange('activity')"
            [ngClass]="{'isActive font-weight-600': activityTab}">
            <i class="fa-solid fa-chart-line mr-2" [ngClass]="{'font-weight-600': activityTab}"></i>
            Activity
        </span>

        <span
          *ngIf="parent !== 'TalentpoolRecommendedCandidateListComponent' && calledfrompage == 'resume-screen' && data?.doc_urls?.length > 0"
          class="py-3 pointer px-8 text-9696" (click)="onTabChange('document')"
          [ngClass]="{'isActive font-weight-600 mb--4': documentTab}">
          <i class="far fa-address-book mr-2" [ngClass]="{'font-weight-600': documentTab}"></i>
          Documents
        </span>

        </div>
    </div>




    <section *ngIf=" profileTab && !isProfileTabCalled" class="w-100 d-flex justify-content-center">
        <img src="../../assets/rolling-loader.gif" style="width: 50px;" alt="">
    </section>

    <section *ngIf="profileTab && isProfileTabCalled">

    <!-- Aegis Connection Card -->
    <div class="aegis-connection mb-3" *ngIf="aegisCandidateData">
      <div class="aegis-connection__header d-flex align-items-center justify-content-between px-3 py-2">
        <div class="d-flex align-items-center">
          <span class="aegis-connection__logo-icon mr-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L4 6V12C4 16.42 7.45 20.55 12 22C16.55 20.55 20 16.42 20 12V6L12 2Z" fill="#2196A6"
                opacity="0.85" />
              <path d="M12 5L7 8V12C7 15.1 9.1 17.97 12 19C14.9 17.97 17 15.1 17 12V8L12 5Z" fill="white" opacity="0.5" />
            </svg>
          </span>
          <span class="aegis-connection__dot mx-2" style="color:#bbb">·</span>

            <span class="aegis-connection__name font-weight-700 f-15 mr-3 text-capitalize">
              {{ aegisCandidateData.mandates.length > 0 && aegisCandidateData.mandates[0].mandatename ? aegisCandidateData.mandates[0].mandatename : 'Mandate Not Available'}}
              {{ aegisCandidateData.mandates.length > 1 ? '+' + (aegisCandidateData.mandates.length - 1) : '' }}
            </span>              
            <span class="aegis-connection__badge d-flex align-items-center">
            <span class="aegis-connection__badge-dot mr-1"></span>
            <span class="f-12">{{ aegisCandidateData.candidatetype }}</span>
          </span>
        </div>
        <a data-testid="auto-app-person-search-candidate-slider-a-5" *ngIf="aegisCandidateData?.atslink" [href]="aegisCandidateData?.atslink" target="_blank" rel="noopener noreferrer" class="aegis-connection__link f-13">
          View in Aegis
          <i class="fa-solid fa-arrow-up-right-from-square ml-1"></i>
        </a>
      </div>
      <div class="aegis-connection__details d-flex align-items-center px-3 py-2">
        <div class="aegis-connection__detail-item d-flex align-items-center mr-4">
          <i class="fa-regular fa-address-card aegis-connection__detail-icon mr-2"></i>
          <div>
            <div class="aegis-connection__detail-label f-11">Contact</div>
            <div class="aegis-connection__detail-value font-weight-600 f-13">{{ aegisCandidateData.contacts ? 'Available' : 'Not Available' }}</div>
          </div>
        </div>
        <div class="aegis-connection__detail-item d-flex align-items-center mr-4">
          <i class="fa-regular fa-clock-rotate-left aegis-connection__detail-icon mr-2"></i>
          <div>
            <div class="aegis-connection__detail-label f-11">Updated</div>
            <div class="aegis-connection__detail-value font-weight-600 f-13">
              <ng-container *ngIf="getFormatedDate(aegisCandidateData.lastupdatedon) as lastUpdated">
                <span *ngIf="lastUpdated.text === 'Today'">Today</span>
                <span *ngIf="lastUpdated.text !== 'Today'">
                  {{ lastUpdated.value }} {{ lastUpdated.type }}{{ lastUpdated.value > 1 ? 's' : '' }} ago
                </span>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="aegis-connection__detail-item d-flex align-items-center mr-4">
          <i class="fa-regular fa-folder aegis-connection__detail-icon mr-2"></i>
          <div>
            <div class="aegis-connection__detail-label f-11">Source</div>
            <div class="aegis-connection__detail-value font-weight-600 f-13">{{ aegisCandidateData?.source || 'N/A' }}</div>
          </div>
        </div>
        <div class="aegis-connection__detail-item d-flex align-items-center">
          <i class="fa-regular fa-circle-user aegis-connection__detail-icon mr-2"></i>
          <div>
            <div class="aegis-connection__detail-label f-11">Owner</div>
            <div class="aegis-connection__detail-value font-weight-600 f-13 text-capitalize">{{ aegisCandidateData.mandates.length > 0 && aegisCandidateData.mandates[0].mandateowner ? aegisCandidateData.mandates[0].mandateowner : 'N/A' }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Aegis Connection Card -->

        <div class="slider-container pt-3" *ngIf="highlightsList?.length">
        <span class="f-14 font-weight-600 d-block mb-3">
            <i class="fa-regular fa-star mr-1"></i>
            Highlights
        </span>

        <div class="w-100 d-flex flex-wrap slider-removengbtooltiparrow removengbtooltiparrow position-relative">

          <div *ngFor="let highlight of highlightsList" class="highlight-pill" [ngClass]="'highlight-pill-' + highlight.color"
            [ngbTooltip]="highlight_chip_tooltip">

            <i class="fa-solid fa-building mr-2" [ngClass]="'briefcase-blank-' + highlight.color" *ngIf="!highlight?.imageName"></i>
            <span *ngIf="highlight?.imageName">
              <img [src]="'assets/highlights/' + highlight.imageName + '.svg'" alt="">
            </span>
            <span class="ml-2">{{ highlight.label }}</span>

            <ng-template #highlight_chip_tooltip>
              <span class=" f-12">
                <span class="">

                  <div
                    *ngIf="highlight.label !== 'Multi-Industry' && highlight.label !== 'Techie' && highlight.label !== 'Promotion Track' && highlight.label !== 'Unicorn Experience'
                                                                  && highlight.label !== 'Same Location' && highlight.label !== 'Nearby Location' && highlight.label !== 'Role Compatibility'
                                                                  && highlight.label !== 'Years of Experience' && highlight.label !== 'Company Size' && highlight.label !== 'Skills Matched'">
                    <div class="hiderule">
                      <div class="position-relative">
                        <!-- <span class="dot custom-tooltip"></span> -->
                         <i class="fa-solid fa-circle"></i>
                        <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                          Candidate has {{ highlight.label.toLowerCase() }} :
                          <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                            {{ item | titlecase }}{{ !last ? ', ' : '.' }}
                          </span>
                        </span>
                      </div>
                      <hr class="highlight-tooltip-divider custom-tooltip">
                    </div>
                  </div>

                  <div *ngIf="highlight.label === 'Techie'">
                    <div class="hiderule">
                      <div class="position-relative">
                        <!-- <span class="dot custom-tooltip"></span> -->
                         <i class="fa-solid fa-circle"></i>
                        <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                          Activity noticed on technology social networks like: GitHub, Stack Overflow,
                          Kaggle, etc.
                        </span>
                      </div>
                      <hr class="highlight-tooltip-divider custom-tooltip">
                    </div>
                  </div>

                  <div *ngIf="highlight.label === 'Multi-Industry'">
                    <div class="hiderule" *ngFor="let item of highlight.value">
                      <div class="position-relative">
                        <!-- <span class="dot custom-tooltip"></span> -->
                        <i class="fa-solid fa-circle"></i>
                        <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Worked in
                          <span class="fw-600">{{item.name | titlecase}}</span>

                          <span class="font-weight-normal f-12" *ngIf="item.exp.year || item.exp.month"> for </span>
                          <span class="font-weight-normal f-12" *ngIf="item.exp.year">{{(item.exp.year
                            == 1)? (item.exp.year +" Year"):(item.exp.year+" Years")}} </span>
                          <span class="font-weight-normal f-12" *ngIf="item.exp.year && item.exp.month">and </span>
                          <span class="font-weight-normal f-12" *ngIf="item.exp.month">{{(item.exp.month == 1)?
                            (item.exp.month +"
                            Month"):(item.exp.month+" Months")}} </span>
                        </span>
                      </div>
                      <hr class="highlight-tooltip-divider custom-tooltip">
                    </div>
                  </div>

                  <div *ngIf="highlight.label === 'Promotion Track'">
                    <div class="hiderule">
                      <div class="position-relative"
                        *ngIf="highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement">
                        <!-- <span class="dot custom-tooltip"></span> -->
                         <i class="fa-solid fa-circle"></i>
                        <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at both current and previous
                          companies.</span>
                      </div>
                      <div class="position-relative"
                        *ngIf="highlight.value?.currentjob_internal_movement && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                        <!-- <span class="dot custom-tooltip"></span> -->
                        <i class="fa-solid fa-circle"></i>
                        <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at current company.</span>
                      </div>
                      <div class="position-relative"
                        *ngIf="highlight.value?.progression_within_pastcompany && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                        <!-- <span class="dot custom-tooltip"></span> -->
                        <i class="fa-solid fa-circle"></i>
                        <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at previous company.</span>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="highlight.label === 'Unicorn Experience'">
                    <div class="hiderule">
                    <div class="position-relative">
                      <!-- <span class="dot custom-tooltip"></span> -->
                       <i class="fa-solid fa-circle"></i>
                      <span class="font-weight-normal f-12 hl-mssg">
                        Candidate has experience in a Unicorn company :
                        <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                          {{ capitalizeFirstLetter(item) }}{{ !last ? ', ' : '.' }} </span>
                        </span>
                    </div>
                    <hr class="highlight-tooltip-divider custom-tooltip">
                  </div>
                  </div>

                  <div *ngIf="highlight.label === 'Same Location' || highlight.label === 'Nearby Location'">
                    <div class="hiderule">
                      <div>
                        <span class="font-weight-normal f-12 hl-mssg custom-tooltip"> This Candidate’s current location
                          <span class="text-capitalize" [innerHTML]="highlight.value"></span>
                          matches with your ideal profile.
                        </span>
                      </div>
                      <hr class="highlight-tooltip-divider custom-tooltip">
                    </div>
                  </div>

                  <div *ngIf="highlight.label === 'Role Compatibility' || highlight.label === 'Years of Experience'">
                    <div class="hiderule">
                      <div>
                        <span *ngIf="highlight.label === 'Role Compatibility'" class="font-weight-normal f-12 hl-mssg">The
                          candidate's
                          job
                          title as a <span class="font-weight-600 text-capitalize" [innerHTML]="highlight.titles"></span> aligns
                          with a
                          closely matching
                          profile.
                        </span>

                        <span *ngIf="highlight.label === 'Years of Experience'" class="font-weight-normal f-12 hl-mssg">The
                          candidate
                          possesses over <span [innerHTML]="totalTenure"></span> years of
                          experience, which
                          closely aligns with your preferred profile.
                        </span>

                      </div>
                      <hr class="highlight-tooltip-divider custom-tooltip">
                    </div>
                  </div>

                  <div *ngIf="highlight.label === 'Company Size' || highlight.label === 'Skills Matched'">
                    <div class="hiderule">
                      <div>

                        <span *ngIf="highlight.label === 'Company Size'" class="font-weight-normal f-12 hl-mssg"> This
                          candidates
                          has
                          worked in a
                          similar company size i.e. <span [innerHTML]="highlight.value"></span> in
                          the past.
                        </span>

                        <span *ngIf="highlight.label === 'Skills Matched'" class="font-weight-normal f-12 hl-mssg"> <span
                            class="text-capitalize" [innerHTML]="highlights.skills"></span>
                          skills present in this candidate that matches with your ideal profile.
                        </span>
                      </div>
                      <hr class="highlight-tooltip-divider custom-tooltip">
                    </div>
                  </div>

                </span>
              </span>
            </ng-template>
          </div>

        </div>
    </div>

    <div class="slider-container pt-3" *ngIf="data.skills && data.skills.length;">
        <span class="f-14 font-weight-600 d-block mb-3" >
            <i class="far fa-book-open mr-1"></i>
            Skills
        </span>
        <div class=" d-flex align-items-baseline" *ngIf="data?.skills?.length > 0">
            <div class="w-100" id="skill_less" [ngStyle]="{'display': !viewMoreSkills ? 'block': 'none'}">

                <div class="d-flex f-12 flex-wrap">
                    <span class="f-14 mb-3"
                        *ngFor="let skill of formattedSkills | slice:0:5; let s = index; last as isLast">
                        <span class="skills-chip mr-2 px-2 py-1 mb-1"  [innerHTML]="highlightInfo(skill, 'skill')"></span>
                            <span class="f-12 pointer text-webbtree-green"
                                (click)="viewmoredetails('skill', 'viewmore')"
                            *ngIf="data?.skills?.length > 5 && s == 4">
                            + {{data?.skills?.length - 5}} more skills
                        </span>
                    </span>
                </div>
            </div>
            <div class="w-100" id="skill_more{{i}}" [ngStyle]="{'display': viewMoreSkills ? 'block': 'none'}">

                <div class="d-flex f-12 flex-wrap">
                    <span class="f-14 mb-3" *ngFor="let skill of formattedSkills; let j = index; last as isLast">
                        <span class="skills-chip mr-2 px-2 py-1 mb-1"  [innerHTML]="highlightInfo(skill, 'skill')"></span>
                    </span>
                    <span class="pointer text-webbtree-green" (click)="viewmoredetails('skill', 'viewless')" *ngIf="data?.skills?.length > 5">
                        view less
                    </span>
                </div>
            </div>
        </div>
    </div>
    <!-- Headline  -->
    <div class="slider-container pt-3" *ngIf="data?.headline">
      <span class="f-14 font-weight-600 d-block mb-2">
        <i class="fa-light fa-circle-user mr-1"></i>
        Headline
      </span>
      <div class="w-100 f-12">
        {{data.headline}}
      </div>
    </div>

    <div class="slider-container pt-3" *ngIf="data.summary">
        <span class="f-14 font-weight-600 d-block mb-2" >
            <i class="far fa-file-pen mr-1"></i>
        Summary
        </span>
        <div class=" d-flex align-items-baseline" >
            <div class="w-100 f-12" >

                <span [innerHtml]="highlightInfo(data?.summary, 'summary')"></span>
            </div>

        </div>
    </div>
    <div class="slider-container pt-3" *ngIf="data.experience && data.experience.length">
        <span class="f-14 font-weight-600 mb-3 d-block">
            <i class="far fa-briefcase mr-1"></i>
            Experience
        </span>


    <div *ngFor="let exp of data.experience; ;let i = index" style="text-transform: capitalize;">
        <div  class="position-relative">
            <div class="d-flex mb-1">
                <div>
                  <span class="clogo c-pointer" (click)="openUrl(exp?.company?.website, 'website')">
                    <i class="fas fa-building" *ngIf="!exp.companylogo" ></i>
                    <img [src]="exp.companylogo" class="img-fluid" *ngIf="exp.companylogo" alt="company name">
                  </span>
                </div>
                <div class=" d-flex justify-content-between w-100">
                  <div>
                    <div class="mb-0" style="line-height: 21px;">


                        <span class="f-14 font-weight-500" style="color: #484b59; margin-bottom: 1px;" *ngIf="exp && exp.title && exp.title.name" [innerHtml]="highlightInfo(exp?.title?.name, 'past_jobtitle')">

                        </span>

                        <span class="d-block f-14" style="margin-bottom: 4px;">

                            <span style="display: inline-block;" class="text-capitalize" *ngIf="exp && exp?.company && exp?.company?.name" (mouseenter)="getCompanyInfo('past',exp, $event)" [ngClass]="{companyHover: exp?.company?.website, 'dstooltip pointer':exp?.company?.website}">
                                <span  [innerHTML]="highlightInfo(exp?.company?.name, 'pastcompany')"></span>

                                <span class="dstooltip-content">
                                    <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                                </span>
                            </span>

                        </span>

                        <div class="d-flex mb-1">
                            <span class="text-969696 f-12 mb-0 text-truncate" style="margin-bottom: 4px; max-width: 50%;" [innerHtml]="highlightInfo(exp?.location_names.toString(), 'location')" matTooltip="{{exp?.location_names.toString()}}" [matTooltipClass]="{ 'red-tooltip': true }">
                            </span>

                            <span class="text-969696 f-12 mb-0" style="margin-bottom: 4px;" *ngIf="exp?.start_date">
                                <i class="fas fa-circle mx-2" style="font-size: 5px;" *ngIf="exp.location_names.length > 0 && exp.start_date"></i> {{formatDate(exp.start_date)}}  - {{exp.end_date != null ? formatDate(exp.end_date) : 'Current'}} {{exp.totaltenure ? '(' + exp.totaltenure + ')' : '' }}
                            </span>
                        </div>
                        <span *ngIf="exp?.expsummary">
                            <span class="f-12 mb-0 exp-list" style="margin-bottom: 4px;"
                                [innerHtml]="highlightInfo(exp?.expsummary, 'exp_summary', {action: 'exp_summary', dataObj: exp?.formattedExpSummary})">
                            </span>
                            <span class="f-12 pointer text-webbtree-green"
                                *ngIf="exp?.formattedExpSummary?.canOverflow && exp?.formattedExpSummary?.isTruncated"
                                (click)="formatDescription('view-more', exp)">
                                view more
                            </span>
                            <span class="f-12 pointer text-webbtree-green"
                                *ngIf="exp?.formattedExpSummary?.canOverflow && !exp?.formattedExpSummary?.isTruncated"
                                (click)="formatDescription('view-less', exp)">
                                view less
                            </span>
                        </span>
                    </div>
                  </div>

                  </div>
                </div>
        </div>

       <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px; margin-bottom: 10px; margin-top: 10px;" *ngIf="i != data.experience.length - 1">


    </div>

    </div>
    <div class="slider-container pt-3" *ngIf="data.education && data.education.length">
        <span class="f-14 font-weight-600 mb-2 d-block pb-3">
            <i class="far fa-user-graduate mr-1"></i>
            Education
        </span>

        <div *ngFor="let edu of data.education; let i = index" class="text-capitalize d-flex flex-column">
            <div class="d-flex">
               <div>
                  <div class="clogo mr-3">
                     <i class="fas fa-graduation-cap f-12"></i>
                  </div>
               </div>
               <div class="w-100">
                  <div>
                     <p style="line-height: 21px" [ngStyle]="(!(edu.newField ? edu.newField : edu.degrees.toString())) ? {'margin-top': '15px'} : {}">
                        <span class="d-block f-14">
                        {{edu.newField ? edu.newField : edu.degrees.toString() }}
                        </span>
                        <span class="text-969696 f-12">
                        <span *ngIf="edu && edu.school && edu.school.name">{{edu.school.name | titlecase}}
                        </span>
                        <span *ngIf="edu?.start_date">
                          <i class="fas fa-circle f-10 mx-1" style="font-size: 3px; margin-top: 0px;" aria-hidden="true"></i>
                          {{formatDate(edu.start_date)}} - {{edu.end_date != null ? formatDate(edu.end_date) : 'Current'}}
                        </span>
                        </span>
                     </p>
                  </div>
               </div>
            </div>
            <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px;" *ngIf="i != data.education.length - 1">
        </div>
    </div>
    <div class="slider-container pt-3" *ngIf="data?.certifications?.length">
      <span class="f-14 font-weight-600 mb-2 d-block pb-3">
        <i class="far fa-file-certificate mr-1"></i>
        Certification
      </span>
      <div *ngFor="let cert of data.certifications; let i = index" class="text-capitalize d-flex flex-column">
        <div class="d-flex">
          <div>
            <div class="clogo mr-3">
              <i class="fa-duotone fa-solid fa-certificate"></i>
            </div>
          </div>
          <div class="w-100">
            <div>
              <p style="line-height: 21px">
                <span class="d-block f-14" [innerHtml]="highlightInfo(cert?.name, 'certification')">
                </span>
                <span class="text-969696 f-12">
                  <span *ngIf="cert?.organization" [innerHtml]="highlightInfo(cert.organization, 'certification')">
                  </span>
                  <span *ngIf="cert?.start_date">
                    <i class="fas fa-circle f-10 mx-1" style="font-size: 3px; margin-top: 0px;" aria-hidden="true"></i>
                    {{formatDate(cert.start_date)}} - {{cert.end_date != null ? formatDate(cert.end_date) : 'Current'}}
                  </span>
                </span>
              </p>
            </div>
          </div>
        </div>
        <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px;" *ngIf="i != data.certifications?.length - 1">
      </div>
    </div>
    <div class="slider-container pt-3" *ngIf="data.interests && data.interests.length">
        <span class="f-14 font-weight-600 mb-3 d-block">
            <i class="far fa-pencil-paintbrush mr-1"></i>
            Interest
        </span>


        <div>

            <span *ngFor="let int of data.interests" class="interest mr-0 px-2 py-1 mb-1">{{int}}</span>

        </div>

    </div>


    </section>






    <section *ngIf="contactTab" class="position-relative">
      <div class="position-relative" *ngIf="calledfrompage !== 'archivepage' && calledfrompage !== 'reviewpage'">
            <app-person-search-contact-slider [candidateDetails]= "data" (handleOutputEvent) = "eventHandler($event)" (revealContactEventEmitter)="getRevealContactStatus($event)"></app-person-search-contact-slider>
       </div>
       <div class="py-4" *ngIf="calledfrompage == 'archivepage' || calledfrompage == 'reviewpage'">
         <img src="../../assets/ai-sourcing/Blur_1.png" alt="" style="width: 100%;">
       </div>
        <!-- <div class="contentonblur" *ngIf="calledfrompage == 'archivepage' || calledfrompage == 'reviewpage'">
              <div class="text-center">
                <span><i class="fa-solid fa-user-circle mb-2 text-webbtree-green f-22"></i></span>

                <p class="f-12 font-weight-600 mb-1">Profile looks relevant?</p>
                <p class="f-12 font-weight-400">Shortlist to access contact details</p>
              </div>
            </div> -->
    </section>
    <section *ngIf="similarTab">
        <app-person-search-similar-slider [candidateDetails]= "similarcandidates" [totalcount]="totalresultcount" [linkedinurl]="linkedin_url" [similartabshow]="issimilartabshow"></app-person-search-similar-slider>
    </section>
    <section *ngIf="activityTab">
        <app-person-search-activity [candidateDetails]= "data"></app-person-search-activity>
    </section>
      <section *ngIf="documentTab">
        <app-person-search-document-slider [candidateDetails]= "data"></app-person-search-document-slider>
    </section>
<section *ngIf="autopilotTab || screenTab">
 <!-- <hr class="my-1"> -->
            <div class="d-flex justify-content-between align-items-center pt-2 pb-1">
                <div class="">
                  <span class="font-weight-600">
                    <!-- <span class="gen-ai-text"> -->
                        <!-- <i class="fa-solid fa-stars"></i> -->
                         Job Compatibility Summary
                    </span>
                    <!-- f-12 -->
                    <span class="ai-copy-btn pointer ml-1 text-9696" (click)="copyToClipboard(data?.screening_response?.overallexplanation)">
                        <i class="fa-regular fa-copy"></i>
                    </span>
                </div>

                <!-- <div class="potential-match-btn" [ngClass]="{'excellent-match-btn' : data?.screening_response?.matchcategory == 'EXCELLENT',
                                                'good-match-btn' : data?.screening_response?.matchcategory == 'GOOD',
                                                'potential-match-btn' : data?.screening_response?.matchcategory == 'POTENTIAL',
                                                'notamatch-match-btn' : data?.screening_response?.matchcategory == 'NOT A MATCH'}">
                    {{showMatchScore(data?.screening_response?.matchcategory)}} | {{data?.screening_response?.overallscore}}%
                    <i class="fa-solid fa-chevron-down ml-3"></i>
                </div> -->


                <div class="criteria-btn-wrapper">
                <div class="potential-match-btn criteria-btn"
                    [ngClass]="{
                        'excellent-match-btn': data?.screening_response?.matchcategory == 'EXCELLENT',
                        'good-match-btn': data?.screening_response?.matchcategory == 'GOOD',
                        'potential-match-btn': data?.screening_response?.matchcategory == 'POTENTIAL',
                        'notamatch-match-btn': data?.screening_response?.matchcategory == 'NOT_A_MATCH'
                        }">
                    {{showMatchScore(data?.screening_response?.matchcategory)}} | {{data?.screening_response?.overallscore | number:'1.0-0'}}%
                    <!-- <i class="fa-solid fa-chevron-down"></i> -->

                    <!-- Tooltip inside wrapper -->
                    <div class="match-criteria">
                    <p><strong>Overall Candidate Score</strong></p>
                    <p>Check the Candidate Score and Fitment to see how well the profile matches the job</p>
                    <p><i class="fa-solid fa-thumbs-up text-excellent"></i> <span style="color: #D9D9D9;" class="mr-2 ml-2">|</span> <span class="text-excellent">Excellent Match</span><span class="float-right">85%+ Above</span></p>
                    <p><i class="fa-solid fa-thumbs-up text-good"></i> <span style="color: #D9D9D9;" class="mr-2 ml-2">|</span> <span class="text-good">Good Match</span><span class="float-right">60% - 85%</span></p>
                    <p><i class="fa-solid fa-thumbs-up text-potential"></i> <span style="color: #D9D9D9;" class="mr-2 ml-2">|</span> <span class="text-potential">Potential Match</span><span class="float-right">40% - 60%</span></p>
                    <p><i class="fa-solid fa-thumbs-down text-danger"></i> <span style="color: #D9D9D9;" class="mr-2 ml-2">|</span> <span class="text-danger">Not a Match</span><span class="float-right">0% - 40%</span></p>
                    </div>
                </div>
                </div>

            </div>
            <hr class="my-1">
            <div class="job-compatibility-container pt-1" id="">
                <div class="job-description p-0 m-0">
                    <!-- <div class="mb-3 text-right">
                        <span class="ai-copy-btn" (click)="copyToClipboard(data?.screening_response?.overallexplanation)">
                            <i class="fa-regular fa-copy"></i>
                        </span>
                    </div> -->
                    <span class="summary-description f-12" [innerHtml]="formatAISummary(data?.screening_response?.overallexplanation)"></span>
                </div>
                <!-- *ngIf="showFullText " -->
                <div class="ai-evaluation-insights" >
                    <p class="f-11" *ngIf="calledfrompage !== 'resume-screen'">Autopilot<sup style="top: -1px !important;"><span>AI</span></sup> Evaluation Insights</p>
                    <p class="f-11" *ngIf="calledfrompage == 'resume-screen'">Screen<sup style="top: -1px !important;"><span>AI</span></sup> Evaluation Insights</p>
                    <div class="evaluation-insights-data mb-2" *ngFor="let criteria of data?.screening_response?.screening_criteria">
                        <p>
                          <span class="f-12 font-weight-500" style="color: #484B59;">{{ criteria?.criteria_content | titlecase}}</span>
                          <span>
                            <i class="fa-solid fa-thumbs-up ml-1" *ngIf="criteria?.match === 'full' || criteria?.match === 'partial' || criteria?.match === 'good'"
                              [ngStyle]="{ color: criteria?.match === 'full' ? '#229300' : criteria?.match === 'partial' ? '#FBA744':  criteria?.match === 'good' ? '#CBCE66' : 'inherit'}">
                            </i>
                            <i class="fa-solid fa-thumbs-down ml-1" *ngIf="criteria?.match === 'unmatched'"
                              [ngStyle]="{ color: criteria?.match === 'unmatched' ? '#CD0F0F8C' : 'inherit'}">
                            </i>
                          </span>
                        </p>

                        <span class="f-12" [innerHtml]="formatAISummary(criteria?.explanation)"></span>
                    </div>
                </div>
                <!-- <button data-testid="auto-app-person-search-candidate-slider-button-2" class="viewmorelessBtn" (click)="toggleView()"> {{ showFullText ? 'View Less' : 'View More' }}</button> -->
            </div>
            <p class="f-10 font-weight-400 mt-2 mb-4 mt-5" style="color: #B8B8B8;">Disclaimer: This qualitative screening is intended to assist in the decision-making process. These recommendations are estimations and may not fully capture the suitability or characteristics of the candidates.</p>
</section>

</div>




<ng-template #getCompanyInformation appCustomTooltip>
  <img [src]="currentCompanyInformation?.companylogo" alt="company name">
  <a data-testid="auto-app-person-search-candidate-slider-a-6" target="_blank" rel="noopener noreferrer" *ngIf="currentCompanyInformation?.linkedin_url" (click)="openUrl(currentCompanyInformation?.linkedin_url, 'linkedin')" class="mr-2">
     <i class="fa fa-linkedin-square f-16"  aria-hidden="true" style="color: #0652ba;"></i>
    </a>

    <i class="fas fa-globe" (click)="openUrl(currentCompanyInformation?.website, 'website')"></i>
  <p>{{currentCompanyInformation?.name}}</p>
  <p>{{currentCompanyInformation?.industry}}</p>
  <p>{{currentCompanyInformation?.location}}</p>
  <p>{{currentCompanyInformation?.size}}</p>
  <p>{{currentCompanyInformation?.tags?.join(', ')}}</p>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
  </ngb-alert>
